<template>
  <div class="select-textfield">
    <v-text-field
      hide-details
      single-line
      append-outer-icon="close"
      @click:append-outer="() => $emit('close_clicked')"
      @change="inputChanged"
    >
      <v-select
        hide-details
        flat
        dense
        v-model="selected_category"
        placeholder="搜索"
        :items="categories"
        :item-value="(item) => item.value"
        :item-text="(item) => item.text"
        append-icon="keyboard_arrow_down"
        slot="prepend-inner"
      ></v-select>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'select-textfield',
  props: {
    'categories': Array
  },
  data() {
    return {
      selected_category: null
    }
  },
  methods: {
    inputChanged(e) {
      if (this.selected_category) {
        let payload = {}
        payload[this.selected_category] = e
        this.$emit('input_changed', payload)
      }
    }
  }
}
</script>

<style>
.select-textfield .v-select__selection {
  max-width: 100% !important;
}
.select-textfield .v-select__selections input {
  max-width: 30px;
}
.select-textfield .v-input {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectTextField.vue